import { useNavigate } from 'react-router-dom';

interface MoodChipsProps {
  profileSlug: string;
  moods: string[];
  activeMood: string | null;
  disabled?: boolean;
}

/**
 * Mood selector chips. Clicking a chip navigates to
 * /r/<profileSlug>/<mood>; the route effect in RadioHomePage picks
 * up the change and asks radioStore to switch streams. When disabled
 * (mid-ad) the chips render greyed out and ignore clicks.
 */
export function MoodChips({
  profileSlug,
  moods,
  activeMood,
  disabled = false,
}: MoodChipsProps) {
  const navigate = useNavigate();

  if (moods.length === 0) return null;

  return (
    <div className="flex gap-2 flex-wrap" data-testid="mood-chips">
      {moods.map((mood) => {
        const isActive = mood === activeMood;
        const baseStyle =
          'px-3 py-1.5 rounded-full text-xs whitespace-nowrap border transition-colors';
        const stateStyle = disabled
          ? 'opacity-40 cursor-not-allowed border-white/10 text-white/50'
          : isActive
            ? 'bg-violet-500/20 border-violet-400 text-white'
            : 'bg-white/5 border-white/10 text-white/70 hover:border-white/30';

        return (
          <button
            key={mood}
            type="button"
            disabled={disabled}
            className={`${baseStyle} ${stateStyle}`}
            onClick={() => {
              if (disabled) return;
              navigate(`/r/${profileSlug}/${encodeURIComponent(mood)}`);
            }}
          >
            {mood}
          </button>
        );
      })}
    </div>
  );
}
